import React, { useState } from 'react';
import { ChevronDown, ChevronUp, MessageCircle } from 'lucide-react';

const CallScript = ({ lead, userName }) => {
  const [expanded, setExpanded] = useState(true);

  const town = lead?.address_town || lead?.post_town || 'the area';
  const firstName = userName ? userName.split(' ')[0] : 'there';
  const businessName = lead?.business_name || 'your business';
  const addressLine1 = lead?.address_line_1 || '';
  const postcode = lead?.address_postcode || '';

  // Estimate arrival time: distance in km → driving minutes (~30mph avg) + 10 min buffer, round to 5
  let etaText = 'around 15 minutes';
  if (lead?.distance != null) {
    const drivingMins = (lead.distance * 0.621371) / 30 * 60;
    const totalMins = Math.max(5, Math.round((drivingMins + 5) / 5) * 5);
    etaText = `around ${totalMins} minutes`;
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-xl overflow-hidden">
      <div className="px-3 pt-2.5 pb-1">
        <div className="flex items-center gap-1.5 text-sm font-semibold text-blue-700 mb-1">
          <MessageCircle size={14} />
          Call Script
        </div>
        {/* Always-visible opening line */}
        <p className="text-sm text-blue-800 leading-relaxed">
          "Hi there, my name's <strong>{firstName}</strong> from <strong>Pestcontrol.co.uk</strong>.
          I've just been doing some work for a business nearby so I thought I'd introduce myself."
        </p>
      </div>

      {expanded && (
        <div className="px-3 pb-1 text-sm text-blue-800 leading-relaxed">
          <p className="mb-2">
            "We're a pest control company covering the <strong>{town}</strong> area and
            I noticed we don't currently handle the pest control
            for <strong>{businessName}</strong>."
          </p>
          <p className="mb-2">
            "What I'd like to do is pop in and give you a <strong>completely free assessment</strong> if
            you've got a minute — no obligation at all, just a quick professional look over your premises.
            I'm right nearby so I won't take up too much of your time."
          </p>
          <p className="mt-2">
            "You're at <strong>{addressLine1}</strong>, <strong>{postcode}</strong> I see —
            now I'm just finishing up here so I can be with you in <strong>{etaText}</strong>,
            is that alright? What was your name? Thanks so much, I look forward to seeing you shortly."
          </p>
        </div>
      )}

      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-center gap-1 py-1.5 text-xs font-medium text-blue-600"
      >
        {expanded ? <>Less <ChevronUp size={14} /></> : <>More <ChevronDown size={14} /></>}
      </button>
    </div>
  );
};

export default CallScript;
